<template>
  <PDialog
    v-if="state.visible"
    :visible="true"
    modal
    position="center"
    :header="state.title"
    :draggable="false"
    :closable="true"
    class="w-10 m-0 px-2 pb-4 md:w-4"
    @update:visible="handleVisibleChange"
  >
    <p v-if="state.message" class="m-0 text-base text-900 line-height-3">
      {{ state.message }}
    </p>

    <div class="flex align-items-stretch gap-2 mt-4">
      <AppActionButton
        :label="state.rejectLabel"
        :severity="state.rejectSeverity"
        labelSize="text-base"
        rootClass="flex-1"
        @click.stop="reject"
      />
      <AppActionButton
        :label="state.acceptLabel"
        :severity="state.acceptSeverity"
        labelSize="text-base"
        rootClass="flex-1"
        @click.stop="accept"
      />
    </div>
  </PDialog>
</template>

<script setup>
import AppActionButton from '@/components/shared/app_action_button.vue'
import { useAppConfirm, useAppConfirmState } from '@/composables/useAppConfirm'

const state = useAppConfirmState()
const { accept, reject } = useAppConfirm()

function handleVisibleChange(visible) {
  if (!visible && state._resolve) {
    reject()
  }
}
</script>
